import { render, staticRenderFns } from "./clear.vue?vue&type=template&id=531ce86c"
import script from "./clear.vue?vue&type=script&lang=js"
export * from "./clear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports